/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import React, { useContext, useMemo, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import ConfigurationContext from "../../../context/Configuration";
import UserContext from "../../../context/User";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import { calculateDistance } from "../../../utils/customFunction";
import { calculateServiceFee } from "../../../utils/serviceFee";

function PricingView(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const configuration = useContext(ConfigurationContext);
  const { cart } = useContext(UserContext);
  const { restaurantData } = props;
  const farDistanceNotice = (
    restaurantData?.freeDelivery?.farDistanceNotice || ""
  ).trim();

  const [deliveryCharges, setDeliveryCharges] = useState(0);
  // True once the address is past the store's far-distance threshold, so the
  // customer is warned here rather than being surprised at checkout
  const [isFarAway, setIsFarAway] = useState(false);
  // How much more the basket needs for free delivery, when that is in reach
  const [freeDeliveryShortfall, setFreeDeliveryShortfall] = useState(0);

  useEffect(() => {
    (async () => {
      if (!restaurantData || !configuration) return;
      const destinationObj = JSON.parse(localStorage.getItem("location"));
      if (!destinationObj) return;
      const latOrigin = Number(restaurantData.location.coordinates[1]);
      const lonOrigin = Number(restaurantData.location.coordinates[0]);
      const latDest = Number(destinationObj.latitude);
      const longDest = Number(destinationObj.longitude);
      
      const distance = await calculateDistance(
        latOrigin,
        lonOrigin,
        latDest,
        longDest
      );
      
      const flatDeliveryFee = configuration.flatDeliveryFee || 0;
      const flatDeliveryLimit = configuration.flatDeliveryLimit || 5;
      const freeDeliveryConfig = restaurantData?.freeDelivery || {};
      const freeMinOrder = freeDeliveryConfig?.minimumOrder
        ? Number(freeDeliveryConfig.minimumOrder)
        : 0;
      const freeDistanceLimit = freeDeliveryConfig?.distanceLimit
        ? Number(freeDeliveryConfig.distanceLimit)
        : 0;
      const freeEnabled = Boolean(freeDeliveryConfig?.isEnabled);
      const itemsAmount = cart.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );

      // The store's own flat fee for anything inside the distance it covers
      const storeFixedFee = Number(freeDeliveryConfig?.fixedFee) || 0;
      const storeFixedFeeDistance =
        Number(freeDeliveryConfig?.fixedFeeDistance) || 0;
      // Past this distance the per-km rate gives way to one flat fee
      const farDistance = Number(freeDeliveryConfig?.farDistance) || 0;
      const farDistanceFee = Number(freeDeliveryConfig?.farDistanceFee) || 0;

      // Only worth saying when spending more would actually earn it
      const canReachFreeDelivery =
        freeEnabled &&
        freeMinOrder > 0 &&
        freeDistanceLimit > 0 &&
        distance <= freeDistanceLimit;
      setFreeDeliveryShortfall(
        canReachFreeDelivery && itemsAmount < freeMinOrder
          ? freeMinOrder - itemsAmount
          : 0,
      );

      let deliveryCharges = 0;
      setIsFarAway(farDistance > 0 && distance > farDistance);
      if (
        freeEnabled &&
        freeMinOrder > 0 &&
        itemsAmount >= freeMinOrder &&
        freeDistanceLimit > 0 &&
        distance <= freeDistanceLimit
      ) {
        deliveryCharges = 0;
      } else if (farDistance > 0 && distance > farDistance) {
        deliveryCharges = farDistanceFee;
      } else if (
        storeFixedFeeDistance > 0 &&
        distance <= storeFixedFeeDistance
      ) {
        deliveryCharges = storeFixedFee;
      } else if (distance <= flatDeliveryLimit) {
        deliveryCharges = flatDeliveryFee;
      } else {
        deliveryCharges = Math.ceil(distance) * restaurantData.restDeliveryRate;
      }

      setDeliveryCharges(deliveryCharges);
    })();
  }, [restaurantData, configuration, cart]);
  const calculatePrice = useMemo(
    () =>
      (amount = 0) => {
        let itemTotal = 0;
        cart.forEach((cartItem) => {
          itemTotal += cartItem.price * cartItem.quantity;
        });
        // if (withDiscount && coupon && coupon.discount) {
        //   itemTotal = itemTotal - (coupon.discount / 100) * itemTotal;
        // }
        const deliveryAmount = amount > 0 ? deliveryCharges : 0;
        return (itemTotal + deliveryAmount).toFixed(2);
      },
    [deliveryCharges, cart]
  );
  const taxCalculation = useMemo(
    () => () => {
      const amount = +calculatePrice(deliveryCharges, true);
      // Percentage or flat amount, with the store's own floor and ceiling
      return calculateServiceFee(restaurantData, amount).toFixed(2);
    },
    [restaurantData, cart, deliveryCharges]
  );

  const calculateTotal = useMemo(
    () => () => {
      let total = 0;
      total += +calculatePrice(deliveryCharges);
      total += +taxCalculation();
      return parseFloat(total).toFixed(2);
    },
    [deliveryCharges, cart]
  );

  // function calculateDistance(){
  //   const service = new window.google.maps.DistanceMatrixService();
  // // build request
  // const destinationObj = JSON.parse(localStorage.getItem('location'))
  // console.log('destinationObj', destinationObj)
  // const origin1 = { lat: Number(restaurantData.location.coordinates[1]), lng: Number(restaurantData.location.coordinates[0]) };
  // const origin2 = restaurantData.address;
  // const destinationA = destinationObj.deliveryAddress;
  // const destinationB = { lat: Number(destinationObj.latitude), lng: Number(destinationObj.longitude) };

  // const request = {
  //   origins: [origin1, origin2],
  //   destinations: [destinationA, destinationB],
  //   travelMode: window.google.maps.TravelMode.DRIVING,
  //   unitSystem: window.google.maps.UnitSystem.METRIC,
  //   avoidHighways: false,
  //   avoidTolls: false,
  // };
  // return service.getDistanceMatrix(request).then((response) => {

  //     let distance = 0;
  //     const originList = response.originAddresses;
  //     distance = response.rows[0].elements[0].distance.value;
  //     for (var i = 0; i < originList.length; i++) {
  //       var results = response.rows[i].elements;
  //       for (var j = 0; j < results.length; j++) {
  //         if(response.rows[i].elements[j].distance.value < distance){
  //           distance = response.rows[i].elements[j].distance.value
  //         }
  //       }
  //     }
  //     return distance
  //   });
  // }

  return (
    <Container
      style={{
        paddingTop: theme.spacing(2),
        background: theme.palette.common.white,
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: theme.spacing(1),
        }}
        className={classes.border}
      >
        <Typography className={classes.subtotalText}>
          {t("subTotal")}
        </Typography>
        <Typography className={classes.subtotalText}>
          {`${configuration.currencySymbol} ${calculatePrice(0)}`}
        </Typography>
      </Box>
      {/* How close the basket is to free delivery */}
      {freeDeliveryShortfall > 0 && (
        <Box style={{ marginTop: theme.spacing(1) }}>
          <Typography
            className={classes.subtotalText}
            style={{ fontWeight: 700 }}
          >
            {t("freeDeliveryShortfall", {
              currencySymbol: configuration.currencySymbol,
              amount: Number(freeDeliveryShortfall).toFixed(2),
            })}
          </Typography>
        </Box>
      )}
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: theme.spacing(1),
        }}
        className={classes.border}
      >
        <Typography className={classes.subtotalText}>
          {t("deliveryFee")}
        </Typography>
        <Typography className={classes.subtotalText}>
          {`${configuration.currencySymbol} ${deliveryCharges.toFixed(2)}`}
        </Typography>
      </Box>
      {/* Why the fee is what it is, before the customer reaches checkout */}
      {isFarAway && farDistanceNotice && (
        <Box style={{ marginTop: theme.spacing(1) }}>
          <Typography variant="caption" color="textSecondary">
            {farDistanceNotice}
          </Typography>
        </Box>
      )}
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: theme.spacing(1),
        }}
        className={classes.border}
      >
        <Typography className={classes.subtotalText}>{t("taxFee")}</Typography>
        <Typography className={classes.subtotalText}>
          {`${configuration.currencySymbol} ${taxCalculation()}`}
        </Typography>
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: theme.spacing(2),
        }}
      >
        <Typography
          style={{ fontWeight: 700, color: theme.palette.text.secondary }}
          className={classes.subtotalText}
        >
          {t("total")}
        </Typography>
        <Typography
          style={{ fontWeight: 700, color: theme.palette.text.secondary }}
          className={classes.subtotalText}
        >
          {`${configuration.currencySymbol} ${calculateTotal()}`}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Box display="flex" alignItems={"center"}>
          <Typography
            style={{
              fontWeight: 700,
              color: theme.palette.text.secondary,
              fontSize: "0.975rem",
            }}
          >
            {`${configuration.currencySymbol} ${calculateTotal()}`}
          </Typography>
          <Typography
            style={{
              ...theme.typography.caption,
              fontWeight: 700,
              color: theme.palette.common.black,
              padding: "5px 10px",
              borderRadius: 5,
              border: "1px solid theme.palette.common.black",
              margin: "0 8px",
            }}
          >
            {cart && cart.length}
          </Typography>
        </Box>
        <Box flexGrow={1} ml={2}>
          <RouterLink to="/checkout" style={{ textDecoration: "none" }}>
            <Button
              style={{
                background: theme.palette.primary.main,
                margin: theme.spacing(2, 0),
                borderRadius: 10,
              }}
              className={classes.checkoutContainer}
            >
              <Typography
                style={{ color: theme.palette.common.black }}
                className={classes.checkoutText}
              >
                {t("goToCheckout")}
              </Typography>
            </Button>
          </RouterLink>
        </Box>
      </Box>
    </Container>
  );
}

export default React.memo(PricingView);
